type FragmentName = 'header' | 'footer';

interface FormlosFragment {
  html: string;
}

export async function fetchFormlosFragment(origin: string, name: FragmentName, signal: AbortSignal): Promise<string> {
  const response = await fetch(`${origin}/wp-json/site-fragments/v1/${name}`, {
    cache: 'no-cache',
    credentials: 'omit',
    signal,
  });

  if (!response.ok) { throw new Error(`Formlos fragment returned ${response.status}`); }
  const fragment: unknown = await response.json();

  if (!fragment || typeof fragment !== 'object' || typeof (fragment as FormlosFragment).html !== 'string') {
    throw new Error('Formlos fragment did not contain HTML');
  }

  return (fragment as FormlosFragment).html;
}
